import { render, staticRenderFns } from "./IdleLogout.vue?vue&type=template&id=5f0fb7ba"
import script from "./IdleLogout.vue?vue&type=script&lang=js"
export * from "./IdleLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports